import { useState } from 'react';
import { Button } from 'react-bootstrap';
import QuestionContentModal from './QuestionContentModal';
import Translated from "./Translated";

const QuestionModalLink = ({ questionId, refetch }) => {
  const [showModal, setShowModal] = useState(false);

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  const editMode = Boolean(questionId);

  return (
    <>
      <Button onClick={openModal}><Translated translationKey={editMode ? "edit" : "create_literal"} /></Button>
      {showModal && (
        <QuestionContentModal 
          questionId={questionId}
          onClose={closeModal}
          onCloseAfterUpdate={refetch}
        />
      )}
    </>
  );
};

export default QuestionModalLink;
